import { Button, Flex, Text } from '@chakra-ui/react';
import { debounce } from 'lodash';
import { useMessageContext } from 'app/components/Chat/context';

export const RetryMessageBlock = () => {
  const {
    message,
    messageActions: { handleRetry },
  } = useMessageContext();
  const debouncedRetry = debounce(() => handleRetry(message), 700);

  return (
    <Flex alignSelf="flex-end" pt={1}>
      <Text color="textError" fontSize="xxs">
        Unable to send message.
      </Text>
      <Button
        variant="text"
        size="auto"
        fontSize="xxs"
        color="textError"
        onClick={debouncedRetry}
        data-testid="messenger-retry-button"
        ml={1}
      >
        RETRY
      </Button>
    </Flex>
  );
};
